import { Environments } from '@content-platform/web-angular-shared-util-configuration';
import { filter, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

const apiEndpoints = {
  applications: '/applications',
  features: '/features',
  roles: '/roles',
  userRoles: '/user-profiles',
  userApplications: '/user-profiles/applications/:uuid',
  userPermissions: '/user-profiles/permissions/:uuid',
};

/**
 * Class with static methods used to get the urls for the api endpoint
 *
 * @export
 * @class ApiParams
 */
@Injectable()
export class ApiParams {

  constructor() 
  {
    // configure the client
    // this.configureClient();
  }

  /**
   * Gets the full url for the given endpoint/type, incase there are dynamic values in the url
   * the user can pass in tokens to replace them.
   *
   * @static
   * @param type
   * @param [tokens] optional tokens for the url
   * @returns the endpoint full url
   */
  getUrl(type: string, tokens?: { [key: string]: string }, useNewGatewayFlag = false) {
    let pattern = apiEndpoints[type];

    if (pattern) {
      if (tokens) {
        Object.keys(tokens).forEach((tokenKey) => {
          const tokenVal = encodeURIComponent(tokens[tokenKey]);
          const tokenStandIn = ':' + tokenKey;
          pattern = pattern.replace(tokenStandIn, tokenVal);
        });
      }


      /* TO DO - these changes are temporary to fix the permissionsEndpoint issue
       Needs to be removed once all the BE services are migrated*/
       
      console.log('***Current Env  ', Environments.getEnvironment());

      console.log('***useNewGatewayFlag ', useNewGatewayFlag);

      let url:any = 
      (useNewGatewayFlag ? Environments.getUrl('permissionsEndpoint'): Environments.getUrl('permissionsEndpointOld')) + pattern;
     
      console.log('***permissionsEndpoint Url  ', url);

      if (url.endsWith('/')) {
        url = url.slice(0, -1);
      }

      console.log('url...', url);

      return url;
    }
  }

  /**
   * Gets the full url for the given endpoint/type, incase there are dynamic values in the url
   * the user can pass in tokens to replace them.
   *
   * @static
   * @param type
   * @param [tokens] optional tokens for the url
   * @returns an observable for endpoint full url
   */
  getUrlAsync(type: string, tokens?: { [key: string]: string }, useNewGatewayFlag = false): Observable<string> {
    
    console.log('***useNewGatewayFlag ', useNewGatewayFlag);
    
    const gateway:any = useNewGatewayFlag ? 'permissionsEndpoint': 'permissionsEndpointOld';
    
    console.log('***permissionsEndpoint type  ', gateway);
    
    return Environments.getUrlAsync(gateway).pipe(
      filter((res) => !!res),
      map((endpointUrl) => {
        let url = '';
        let pattern = apiEndpoints[type];
        if (pattern) {
          if (tokens) {
            Object.keys(tokens).forEach((tokenKey) => {
              const tokenVal = encodeURIComponent(tokens[tokenKey]);
              const tokenStandIn = ':' + tokenKey;
              pattern = pattern.replace(tokenStandIn, tokenVal);
            });
          }
          url = endpointUrl + pattern;

          if (url.endsWith('/')) {
            url = url.slice(0, -1);
          }
        }

        console.log('getUrlAsync...url...', url);
        return url;
      })
    );
  }
}
